import { useQuery } from '@tanstack/react-query';

import { locationClient } from '../clients/locationClient';

import { cacheKeys } from '../config';


type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useAddressSearch = (q: string, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.searchAddress, q],
    queryFn: () => locationClient.searchAddress(q),
    ...options,
  });

  return {
    ...rest,
    results: data || [],
  };
};
